/*
 * routing details need to be defined in here 
 * instead of in their own files because 
 * otherwise it interferes with the active 
 * tab visual style ¯\_(ツ)_/¯
 */

import Vue from 'vue';
import { IonicVueRouter } from '@ionic/vue';

Vue.use(IonicVueRouter);

const router = new IonicVueRouter({
    mode: 'history',

    routes: [
        {
            path: '/',
            name: 'LoginPage',
            component: () => import('./pages/login/index.vue'),
        },
        {
            path: '/action',
            name: 'ActionPage',
            component: () => import('./pages/action/index.vue'),
            meta: {
                tab: 'action',
                type: 'list',
            }
        },
        {
            path: '/action/search',
            name: 'SearchPage',
            component: () => import('./pages/search/index.vue'),
            meta: {
                tab: 'action',
                type: 'list',
            }
        },
        {
            path: '/action/emergency-events',
            name: 'EmergencyEventsPage',
            component: () => import('./pages/emergency-events/index.vue'),
            meta: {
                tab: 'action',
                type: 'list',
            }
        },
        {
            path: '/topic/:slug',
            name: 'ArticlePage',
            component: () => import('./pages/article/index.vue'),
            meta: {
                tab: 'action',
                type: 'detail',
            }
        },
        {
            path: '/action/emergency-events/list-:id',
            name: 'EmergencyEventsArticleListPage',
            component: () => import('./pages/article-list/index.vue'),
            meta: {
                tab: 'action',
                type: 'list',
            }
        },
        {
            path: '/action/emergency-events/*/list-:id',
            name: 'EmergencyEventsArticleInnerListPage',
            component: () => import('./pages/article-inner-list/index.vue'),
            meta: {
                tab: 'action',
                type: 'list',
            }
        },
        {
            path: '/action/emergency-messages',
            name: 'EmergencyMessagesPage',
            component: () => import('./pages/emergency-messages/index.vue'),
            meta: {
                tab: 'action',
                type: 'list'
            }
        },
        {
            path: '/action/emergency-messages/group-types',
            name: 'MessagingGroupTypesPage',
            component: () => import('./pages/messaging-group-types/index.vue'),
            meta: {
                tab: 'action',
                type: 'list'
            }
        },
        {
            path: '/action/emergency-messages/floors',
            name: 'MessagingFloorsPage',
            component: () => import('./pages/messaging-floors/index.vue'),
            meta: {
                tab: 'action',
                type: 'list'
            }
        },
        {
            path: '/action/emergency-messages/notification-types',
            name: 'MessagingNotificationTypesPage',
            component: () => import('./pages/messaging-notification-types/index.vue'),
            meta: {
                tab: 'action',
                type: 'list'
            }
        },
        {
            path: '/action/emergency-messages/choose-message',
            name: 'MessagingChooseMessagePage',
            component: () => import('./pages/messaging-choose-message/index.vue'),
            meta: {
                tab: 'action',
                type: 'list'
            }
        },
        {
            path: '/action/emergency-messages/available-messages',
            name: 'MessagingAvailableMessagesPage',
            component: () => import('./pages/messaging-available-messages/index.vue'),
            meta: {
                tab: 'action',
                type: 'list'
            }
        },
        {
            path: '/action/emergency-messages/compose-message',
            name: 'MessagingComposeMessagePage',
            component: () => import('./pages/messaging-compose-message/index.vue'),
            meta: {
                tab: 'action',
                type: 'list'
            }
        },
        {
            path: '/action/emergency-messages/preview',
            name: 'MessagingPreviewPage',
            component: () => import('./pages/messaging-preview/index.vue'),
            meta: {
                tab: 'action',
                type: 'list'
            }
        },
        {
            path: '/action/pre-plans',
            name: 'PrePlansPage',
            component: () => import('./pages/pre-plans/index.vue'),
            meta: {
                tab: 'action',
                type: 'list',
            }
        },
        {
            path: '/document/:id',
            name: 'DocumentPage',
            component: () => import('./pages/document/index.vue'),
            meta: {
                tab: 'action',
                type: 'detail',
            }
        },
        {
            path: '/action/operations',
            name: 'OperationsPage',
            component: () => import('./pages/operations/index.vue'),
            meta: {
                tab: 'action',
                type: 'list',
            }
        },
        {
            path: '/action/operations/contacts',
            name: 'ContactsPage',
            component: () => import('./pages/contacts/index.vue'),
            meta: {
                tab: 'action',
                type: 'list',
            }
        },
        {
            path: '/action/operations/contacts/:id',
            name: 'ContactDetailPage',
            component: () => import('./pages/contact-detail/index.vue'),
            meta: {
                tab: 'action',
                type: 'detail',
            }
        },
        {
            path: '/action/operations/fixtures',
            name: 'FixturesPage',
            component: () => import('./pages/fixtures/index.vue'),
            meta: {
                tab: 'action',
                type: 'list',
            }
        },
        {
            path: '/action/operations/fixtures/:id',
            name: 'FixtureDetailPage',
            component: () => import('./pages/fixture-detail/index.vue'),
            meta: {
                tab: 'action',
                type: 'detail',
            }
        },
        {
            path: '/action/operations/preparedness',
            name: 'PreparednessPage',
            component: () => import('./pages/preparedness/index.vue'),
            meta: {
                tab: 'action',
                type: 'list',
            }
        },
        {
            path: '/action/operations/preparedness/list-:id',
            name: 'PreparednessArticleListPage',
            component: () => import('./pages/article-list/index.vue'),
            meta: {
                tab: 'action',
                type: 'list',
            }
        },
        {
            path: '/action/operations/preparedness/*/list-:id',
            name: 'PreparednessArticleInnerListPage',
            component: () => import('./pages/article-inner-list/index.vue'),
            meta: {
                tab: 'action',
                type: 'list',
            }
        },
        {
            path: '/action/operations/recovery',
            name: 'RecoveryPage',
            component: () => import('./pages/recovery/index.vue'),
            meta: {
                tab: 'action',
                type: 'list',
            }
        },
        {
            path: '/action/operations/recovery/list-:id',
            name: 'RecoveryArticleListPage',
            component: () => import('./pages/article-list/index.vue'),
            meta: {
                tab: 'action',
                type: 'list',
            }
        },
        {
            path: '/action/operations/recovery/*/list-:id',
            name: 'RecoveryArticleInnerListPage',
            component: () => import('./pages/article-inner-list/index.vue'),
            meta: {
                tab: 'action',
                type: 'list',
            }
        },
        {
            path: '/annotations',
            name: 'AnnotationsPage',
            component: () => import('./pages/annotations/index.vue'),
            meta: {
                tab: 'annotations',
                type: 'list',
            }
        },
        {
            path: '/annotations/:id',
            name: 'AnnotationDetailPage',
            component: () => import('./pages/annotation-detail/index.vue'),
            meta: {
                tab: 'annotations',
                type: 'detail',
            }
        },
        {
            path: '/account',
            name: 'AccountPage',
            component: () => import('./pages/account/index.vue'),
            meta: {
                tab: 'account',
                type: 'list',
            }
        },
        {
            path: '/account/profile',
            name: 'ProfilePage',
            component: () => import('./pages/profile/index.vue'),
            meta: {
                tab: 'account',
                type: 'detail',
            }
        },
        {
            path: '/account/subscriptions',
            name: 'SubscriptionsPage',
            component: () => import('./pages/subscriptions/index.vue'),
            meta: {
                tab: 'account',
                type: 'detail',
            }
        },
        {
            path: '/account/storage-sync',
            name: 'StorageSyncPage',
            component: () => import('./pages/storage-sync/index.vue'),
            meta: {
                tab: 'account',
                type: 'detail',
            }
        },
        // Forgot Password Flow
        {
            path: "/forgot-password/forgot-password-email",
            name: "ForgotPasswordEmail",
            component: () =>
                import("./pages/forgot-password/forgot-password-email/index.vue"),
        },

        {
            path: "/forgot-password/forgot-password-question",
            name: "ForgotPasswordQuestion",
            component: () =>
                import("./pages/forgot-password/forgot-password-question/index.vue"),
        },

        {
            path: "/forgot-password/change-password",
            name: "ChangePassword",
            component: () =>
                import("./pages/forgot-password/change-password/index.vue"),
        },
    ],
});

export default router;